import { useEffect, useState } from 'react'
import stepItemList from '../../models/StepItemList'
import { getConfig } from '../../services/config-service'
import TabContent from '../TabContent/TabContent'
import StepItem from '../elements/StepItem/StepItem'
import styles from './Scheduler.module.scss'

export function Scheduler(): any {
  const [isLoading, setIsLoading] = useState(true)
  const enableRezSchedulerValue = getConfig<boolean>('enableRezScheduler', false)
  useEffect(() => {
    if (typeof enableRezSchedulerValue !== 'undefined') {
      setIsLoading(false)
    }
  }, [enableRezSchedulerValue])
  const filteredStepItems = stepItemList.filter((item) => item.isShown)
  const stepItems = filteredStepItems.map((item, index) => {
    return <StepItem key={index} stepIndex={index + 1} stepId={item.stepId} description={item.description} />
  })
  return (
    <>
      <div className={`${styles.Scheduler} ${!(enableRezSchedulerValue ?? false) ? styles.InactiveTabs : ''} tabScheduler`} data-testid='Scheduler'>
        {stepItems}
      </div>
      {isLoading ? <p>Loading...</p> : <TabContent />}
    </>
  )
}

export default Scheduler
